import { NavLink, Outlet } from "react-router-dom";
import { Logo } from "../components/Logo";

const adminLinks = [
  { label: "لوحة المؤشرات", href: "/admin" },
  { label: "الطلبات", href: "/admin/requests" },
  { label: "سجل التدقيق", href: "/admin/audit-logs" },
];

export function AdminLayout() {
  return (
    <div className="min-h-screen bg-sand text-graphite">
      <header className="border-b border-line bg-white">
        <div className="container flex min-h-[74px] items-center justify-between gap-4">
          <NavLink to="/">
            <Logo />
          </NavLink>
          <span className="hidden sm:inline-flex">
            <span className="status-badge status-badge-info">
              إدارة داخلية محمية عبر Cloudflare Access
            </span>
          </span>
        </div>
      </header>
      <div className="container grid gap-6 py-8 lg:grid-cols-[240px_1fr]">
        <aside className="rounded-lg border border-line bg-white p-3 shadow-card">
          <nav className="grid gap-1">
            {adminLinks.map((link) => (
              <NavLink
                key={link.href}
                to={link.href}
                end={link.href === "/admin"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-bold ${
                    isActive ? "bg-charcoal text-white" : "text-graphite hover:bg-sand"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
